import React from "react";
import moment from "moment";
import classNames from "classnames";
import { Tooltip } from "antd";

class Message extends React.Component {
  render() {
    const { comment, user, children } = this.props;
    const formatDate =
      moment().dayOfYear() !== moment(comment.createdAt).dayOfYear()
        ? "LLL"
        : "HH:mm";
    return (
      <div className="message" key={comment.id}>
        <div
          className={classNames({
            "message-in": true,
            own: user.id === comment.author,
            other: user.id !== comment.author
          })}
        >
          <Tooltip
            placement={user.id === comment.author ? "right" : "left"}
            title={moment(comment.createdAt).format(formatDate)}
            mouseLeaveDelay={0}
          >
            <div
              className={classNames({
                "message-bubble": true,
                own: user.id === comment.author,
                other: user.id !== comment.author
              })}
            >
              {!comment.admin ? null : (
                <div
                  style={{
                    fontSize: "xx-small",
                    color: "var(--color-blue-com)"
                  }}
                >
                  admin
                </div>
              )}
              {children}
            </div>
          </Tooltip>
        </div>
      </div>
    );
  }
}

export default Message;



// WEBPACK FOOTER //
// ./src/Components/Comments/MessageBubble.js